/* eslint-disable react-hooks/exhaustive-deps */
// Core
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Styles
import { CommonGlassContainer, Label } from "assets/styles/globalStyles";

// Types
import {
    ArticlesGrid,
    AwardLists,
    FounderWrapper
} from "./styles";

// Components
import Loader from "components/Loader";

// Others
import { fetchData } from "utils/fetch";
import { restAPIs } from "utils/restAPIs";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { WinningCard } from "pages/Homepage/styles";
import { FontSizes, FontWeight } from "utils/enums";
import { colors } from "assets/styles/colors";

import AOS from "aos";
import { Button, Flex, Tooltip } from "antd";

import { PhotoProvider, PhotoView } from 'react-photo-view';
import ReactPlayer from 'react-player';
import { ArrowLeftOutlined, BackwardOutlined } from '@ant-design/icons';
import ArticleView from "./ArticleView";



const AwardAll: React.FC = () => {
    const { currentLang } = useSelector((store: any) => store.commonData);
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const { t } = useTranslation();
    const [photos, setPhotos] = useState([])
    const [videos, setVideos] = useState([])
    const [awards, setData] = useState<any>([]);
    const { type, typeId } = useParams();
    const [awardStatementTitle, setAwardStatementTitle] = useState('')
    const [awardStatementDesc, setAwardStatementDesc] = useState('')
    const [isAuthor, setAuthor] = useState(false)
    const [articles, setArticles] = useState([])
    const [isOpenArticle, setOpenArticle] = useState(false)
    const [article, setArticle] = useState<any>(null)


    const filterIcons = {
        CameraswitchIcon: <svg xmlns="http://www.w3.org/2000/svg" height="16" width="20" viewBox="0 0 640 512"><path d="M213.1 64.8L202.7 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM192 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z" /></svg>,
    }

    useEffect(() => {
        AOS.init({
            duration: 800, // Animation duration in milliseconds
            easing: 'ease-in-out', // Easing function for the animation
            once: false, // Ensures the animation runs every time the element is in view
        });

        const handleScroll = () => {
            AOS.refresh();
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    const fetchAwards = async () => {
        setLoading(true)
        const res = type === 'year' ? await fetchData(restAPIs.awardsList(currentLang?.id, null, typeId)) : await fetchData(restAPIs.awardsList(currentLang?.id, typeId, null))
        setData(res.items)
        setArticles(res.articles)
        if (res.photos)
            setPhotos(res.photos)
        if (res.videos)
            setVideos(res.videos)
        if (res.awardStatementTitle)
            setAwardStatementTitle(res.awardStatementTitle)
        if (res.awardStatementDesc)
            setAwardStatementDesc(res.awardStatementDesc)

        setLoading(false);
    }

    useEffect(() => {
        fetchAwards()
        window.scrollTo(0, 0);
    }, [currentLang]);

    const handleBook = (bookId: any) => {
        navigate(`/book/${bookId}`)
    }

    const toggleImg = () => {
        setAuthor(!isAuthor)
    }

    const handleOpenArticle = (item: any) => {
        setArticle(item)
        setOpenArticle(true)
    }



    // if (pageLoading) return <Loader />;

    return (
        <>
            <FounderWrapper
                direction={(currentLang?.id) === 1 ? "rtl" : "ltr"}
            >
                <div className="container">

                    <div className="row justify-content-center">
                        <div className="col-md-11">
                            <CommonGlassContainer>
                                <Flex justify="space-between" align="center" gap={20}>
                                    <motion.div
                                        style={{ marginLeft: '-8px' }}
                                        className='mb-5 d-flex flex-column'
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <Label className="fade-left" pointer fontSize={FontSizes.h3} onClick={()=>navigate(-1)} fontWeight={FontWeight.bold} marginTop={3} marginBottom={10}><ArrowLeftOutlined /> Back</Label>
                                        <Label className="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={0} marginBottom={5}>Ibn Battuta Awards</Label>
                                        <Label className="fade-left" color={colors.secondary} fontSize={FontSizes.h2} fontWeight={FontWeight.bold} marginTop={0} marginBottom={5}>{type !== 'year' ? awards[0]?.categoryName : awards[0]?.year}</Label>
                                    </motion.div>
                                    <motion.div
                                        style={{ marginLeft: '-8px' }}
                                        className='mb-5'
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <Button className='__filt_btn' style={{ margin: '0 10px' }} title={isAuthor ? 'Switch to see book images' : 'Switch to see author images'} onClick={() => toggleImg()}  icon={filterIcons?.CameraswitchIcon}><span>{isAuthor ? 'Books' : 'Awardees'}</span></Button>
                                    </motion.div>
                                </Flex>

                                {
                                    isLoading ? <Loader /> :
                                        <>
                                            <AwardLists>
                                                {
                                                    awards.map((item: any, i: any) => {
                                                        return (
                                                            <div
                                                                className="mb-4"
                                                                style={{ width: '100%' }}
                                                                key={i}
                                                                data-aos="fade-left" 
                                                                data-aos-delay={i * 200}
                                                            >
                                                                <WinningCard className="fade-left"onClick={() => handleBook(item.bookId)}>
                                                                    <div className="book">
                                                                        <div className="cover" style={{ backgroundImage: `url(${isAuthor ? item.authorImage : item.coverImage})` }}></div>
                                                                        <div className="__category">{item.categoryName}</div>
                                                                    </div>

                                                                    <div className="__content">
                                                                        <Tooltip title={item.bookName}>
                                                                            <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h2} marginBottom={15}>
                                                                                {item.bookName}
                                                                            </Label>
                                                                        </Tooltip>
                                                                        <Tooltip title={`${item.authorName}`}>
                                                                            <p className="__author">{item.authorName}</p>
                                                                        </Tooltip>
                                                                        <Tooltip title={` ${item.categoryName}`}>
                                                                            <p>{item.categoryName}</p>
                                                                        </Tooltip>
                                                                        <p style={{ color: colors.darkPrimary }}>{item.year}</p>
                                                                    </div>
                                                                </WinningCard>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>

                                            </AwardLists>

                                            <div className='mt-5' dir={currentLang?.id === 1 ? 'rtl' : 'ltr'}>
                                                <Label fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={20} marginBottom={20}>{awardStatementTitle && awardStatementTitle}</Label>
                                                <p dangerouslySetInnerHTML={{ __html: awardStatementDesc && awardStatementDesc }} style={{ lineHeight: '2', margin: '10px 0' }}></p>
                                            </div>
                                            
                                            <Label fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={50} marginBottom={30}>Gallery</Label>

                                            <ArticlesGrid>
                                                {
                                                    articles?.map((item: any, i: any) => {
                                                        return (
                                                            <motion.div
                                                                className='__col_item'
                                                                style={{ width: '100%',cursor: 'pointer', position: 'relative' }}
                                                                data-aos="fade-left"
                                                                initial={{ opacity: 0, x: -50 }}
                                                                animate={{ opacity: 1, x: 0 }}
                                                                transition={{ duration: 0.5 }}
                                                                key={i}
                                                                onClick={() => handleOpenArticle(item)}
                                                            >
                                                                <img src={item.publicationIcon} alt={item.name} style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '10px' }} />
                                                                <div className="_____gradient">
                                                                <Label color={'#fff'} fontSize={FontSizes.table} marginBottom={5} pointer>
                                                                    {item.name}
                                                                </Label>
                                                                </div>
                                                            </motion.div>
                                                        )
                                                    })
                                                }
                                            </ArticlesGrid>
                                        </>

                                }
                            </CommonGlassContainer>
                        </div>
                    </div>
                </div>
            </FounderWrapper>

            <ArticleView
                open={isOpenArticle}
                onClose={()=>setOpenArticle(false)}
                data={article}
            />
        </>
    );
};

export default AwardAll;

